import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

import ExperienceModalRoutes from './ExperienceModals';

const AsyncExperienceContactHostSuccess = Load(
  () =>
    import(
      /* webpackChunkName: "experience-contact-host-form" */ 'modules/experience/containers/ContactHostSuccessContainer'
    ),
  {},
  true,
);
const AsyncExperienceContactHostSendingModal = Load(
  () =>
    import(
      /* webpackChunkName: "experience-contact-host-form" */ 'modules/experience/containers/ContactHostSendingModalContainer'
    ),
  {},
  true,
);
const AsyncExperienceContactHostForm = Load(
  () =>
    import(
      /* webpackChunkName: "experience-contact-host-form" */ 'modules/experience/containers/ContactFormContainer'
    ),
  {},
  true,
);
const AsyncExperienceProductPage = Load(
  () =>
    import(/* webpackChunkName: "experience-page" */ './ExperienceProductPage'),
  {},
  true,
);
const AsyncExperienceLocalContainer = Load(
  () =>
    import(
      /* webpackChunkName: "experience-local-picker" */ './ExperienceLocalContainer'
    ),
);
const AsyncExperienceReviewsPage = Load(
  () =>
    import(
      /* webpackChunkName: "experience-reviews-page" */ './components/ExperienceReviewsPage'
    ),
  {},
  true,
);

const AsyncLocalContactHostSuccess = Load(
  () =>
    import(
      /* webpackChunkName: "local-contact-host-form" */ 'modules/experience/components/PickLocal/modals/ContactHostSuccessContainer'
    ),
  {},
  true,
);
const AsyncLocalContactHostSendingModal = Load(
  () =>
    import(
      /* webpackChunkName: "local-contact-host-form" */ 'modules/experience/components/PickLocal/modals/ContactHostSendingModalContainer'
    ),
  {},
  true,
);
const AsyncLocalContactHostForm = Load(
  () =>
    import(
      /* webpackChunkName: "local-contact-host-form" */ 'modules/experience/components/PickLocal/modals/ContactFormContainer'
    ),
  {},
  true,
);

const ExperienceRoutes = [
  ...ExperienceModalRoutes,
  <NavigationableLayout
    key="contact.modal.success"
    path={`${basePath}/experience/:id/contact/:hostId/:form/success/`}
    component={AsyncExperienceContactHostSuccess}
    showSearchInNavbar
    noNavbar={isCordova()}
    hideFooter
  />,
  <Route
    key="contact.modal.sending"
    path={`${basePath}/experience/:id/contact/:hostId/:form/sending/`}
    component={AsyncExperienceContactHostSendingModal}
  />,
  <NavigationableLayout
    key="contact.form"
    path={`${basePath}/experience/:id/contact/:hostId/:form/`}
    component={AsyncExperienceContactHostForm}
    hideFooter
  />,
  <NavigationableLayout
    key="local-contact-host-form-success"
    path={`${basePath}/experience/:id/locals/contact/:hostId/:form/success/`}
    component={AsyncLocalContactHostSuccess}
    showSearchInNavbar
    hideFooter
  />,
  <Route
    key="local-contact-host-form-sending"
    path={`${basePath}/experience/:id/locals/contact/:hostId/:form/sending/`}
    component={AsyncLocalContactHostSendingModal}
  />,
  <NavigationableLayout
    key="local-contact-host-form"
    path={`${basePath}/experience/:id/locals/contact/:hostId/:form/`}
    component={AsyncLocalContactHostForm}
    hideFooter
  />,
  <Route
    key="product.page.locals"
    path={`${basePath}/experience/:id/locals`}
    component={AsyncExperienceLocalContainer}
  />,
  <Route
    key="experience.reviews.paginated"
    path={`${basePath}/experience/:id/reviews/page/:page/`}
    component={AsyncExperienceReviewsPage}
  />,
  <Route
    key="experience.reviews"
    path={`${basePath}/experience/:id/reviews/`}
    component={AsyncExperienceReviewsPage}
  />,
  <NavigationableLayout
    key="product.page"
    nonFixedNavbar
    path={`${basePath}/experience/:id`}
    component={AsyncExperienceProductPage}
    showSearchInNavbar
    noNavbar={isCordova()}
  />,
];

export default ExperienceRoutes;
